import { cn } from 'src/lib/utils'

interface SuggestedMarkerProps {
  className?: string
}

export const SuggestedMarker = ({ className }: SuggestedMarkerProps): React.ReactElement => {
  return (
    <h5 className={cn('text-primary-gray font-evogria text-xl lg:text-2xl uppercase py-3 bg-primary text-center', className)}>
      Suggested
    </h5>
  )
}
